<template>
  <div class="login-bg">
    <div class="wrapper login">
      <div class="row">
        <div class="col text-center">
          <div class="logo-brand">Pesquisa<span> de Clima</span></div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 offset-2 text-center">
          <form @submit.prevent="login">
            <div class="alert alert-info" v-if="!auth">
              Usuários Modern Logistics usem seu usuário/matricula e senha do AD
            </div>

            <div class="white mb-3" v-if="auth">
              Bem-vindo <b>{{ authData.givenname }}</b>
            </div>

            <a
              v-if="!auth"
              :href="
                'https://idp.modern.humanflow.com.br/simplesaml/custom.php?redirect_url=' +
                $store.state.frontUrl +
                'login'
              "
              class="btn btn-tasks btn-block clickable"
              >Login com AD
            </a>
            <router-link
              v-if="!auth"
              :to="'/login-email'"
              class="btn btn-tasks btn-block clickable"
              >Login com Email
            </router-link>
            <button v-if="auth" class="btn btn-tasks btn-block clickable">
              Continuar para o Pesquisa
            </button>
          </form>
        </div>
      </div>

      <footer class="white">
        <div>
          Desenvolvido por
          <img src="../assets/images/logo-innovare.png" alt="" />
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      auth: false,
      authData: {},
    };
  },
  mounted() {
    if (this.$route.query.param != "" && this.$route.query.param != undefined) {
      this.auth = true;

      let data = atob(this.$route.query.param);
      data = JSON.parse(data);
      this.authData = {};
      for (let prop in data.attributes) {
        this.authData[
          prop
            .replace(
              "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/",
              ""
            )
            .replace(
              "http://schemas.microsoft.com/ws/2008/06/identity/claims/",
              ""
            )
        ] = data.attributes[prop][0];
      }

      this.authData.logoutUrl = data.logoutUrl;
    }
  },
  methods: {
    login() {
      const self = this;
      const api = this.$store.state.api + "adfsAuth";

      axios
        .post(api, {
          register: self.authData.windowsaccountname,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          self.$router.push("/");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Roboto", sans-serif;
}
form .form-input {
  width: 90% !important;
  font-size: 15px !important;
  padding: 10px !important;
  border: 1px solid #c0c0c0;
}
form .form-label {
  width: 90% !important;
  display: block;
  text-align: left;
  font-size: 16px !important;
  margin-left: auto;
  margin-right: auto;
}
form .form-button {
  width: 90%;
  padding: 10px;
  font-size: 18px;
  border-radius: 30px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #f0f0f0;
  background: #1197d6 !important;
  color: white;
}

#myModal {
  text-align: left;
}

@media (max-width: 768px) {
  .ibox {
    margin: 0px 0px 0px 0px;
  }
}

form label {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue